export const WIZARD_PROFILE_DEFAULTS_BY_EQUIPMENT = {
    Barbell: {
        equipmentFamily: "free_weight",
        implement: "barbell",
    },
    Dumbbell: {
        equipmentFamily: "free_weight",
        implement: "dumbbell",
    },
    Cable: {
        equipmentFamily: "cable",
    },
    Machine: {
        equipmentFamily: "machine",
    },
    "Smith Machine": {
        equipmentFamily: "machine",
        implement: "barbell",
    },
    "Specialty Bar": {
        equipmentFamily: "free_weight",
        implement: "specialty_bar",
    },
    Functional: {
        equipmentFamily: "other",
    },
    Kettlebell: {
        equipmentFamily: "free_weight",
        implement: "kettlebell",
    },
    "Medicine Ball": {
        equipmentFamily: "free_weight",
        implement: "medicine_ball",
    },
    Bodyweight: {
        equipmentFamily: "bodyweight",
    },
    "Cardio Machine": {
        equipmentFamily: "cardio",
    },
    Other: {
        equipmentFamily: "other",
        implement: "other",
    },
};

export const WIZARD_PROFILE_OVERRIDES_BY_ID = {
    bench_press: {
        support: "bench",
        movement: "press",
        mainArea: "chest",
    },
    incline_bench_press: {
        support: "bench",
        movement: "press",
        mainArea: "chest",
    },
    decline_bench_press: {
        support: "bench",
        movement: "press",
        mainArea: "chest",
    },
    close_grip_bench_press: {
        support: "bench",
        movement: "press",
        mainArea: "arms",
    },
    lat_pulldown: {
        support: "seat",
        movement: "pull",
        mainArea: "back",
    },
    machine_row: {
        support: "seat",
        movement: "pull",
        mainArea: "back",
    },
    seated_calf_raise: {
        support: "seat",
        movement: "raise_or_curl",
        mainArea: "legs",
    },
    pull_up: {
        support: "hanging",
        movement: "pull",
        mainArea: "back",
    },
    chin_up: {
        support: "hanging",
        movement: "pull",
        mainArea: "back",
    },
    bodyweight_dips: {
        movement: "press",
        mainArea: "chest",
    },
};
